<template>
  <div v-if="loading">
    <Loading />
  </div>
  <div class="content w-full">
    <TopNavbar />
    <div class="page-content">
      <template v-if="appData && appCountries">
        <AppInfo
          :appData="appData"
          :appCountries="appCountries"
          :defaultTab="defaultTab"
          :historyId="historyId"
          @get-app="fetchData"
        />
      </template>
      <template v-else-if="isEmpty">
        <NotFoundContent :message="$t('Apps.notFound')" />
      </template>
    </div>
  </div>
  <NotificationComponent
    v-if="notification.show"
    :key="notification.key"
    :type="notification.type"
    :title="notification.title"
    :message="notification.message"
    @closed="!notification.show"
  />
</template>

<script>
import TopNavbar from "@/components/user/layout/TopNavbar.vue";
import AppOverviewComponent from "@/components/user/viewComponent/app/AppOverviewComponent.vue";
import Loading from "@/components/user/layout/LoadingComponent.vue";
import NotificationComponent from "@/components/custom/notifications/NotificationComponent.vue";
import NotFoundContent from "@/components/user/common/NotFoundContent.vue";
import AppInfo from "@/components/user/viewComponent/app/AppInfo.vue";
import { getApp, getAppByStoreId, getAppCountries, processAppByStoreId } from "@/api/app.api";

export default {
  name: "AppViewComponent",
  components: {
    TopNavbar,
    AppOverviewComponent,
    Loading,
    AppInfo,
    NotificationComponent,
    NotFoundContent,
  },
  data() {
    return {
      storeId: this.$route.params.storeId,
      country: this.$route.query.country || "US",
      historyId: this.$route.query.historyId,
      defaultTab: "overview",
      loading: false,
      appData: null,
      appCountries: null,
      isEmpty: false,
      notification: {
        show: false,
        key: 0,
        type: "",
        title: "",
        message: "",
      },
    };
  },
  async created() {
    this.loading = true;
    if (!this.storeId) return;
    if (this.historyId){
      this.defaultTab = "history";
    }
    try {
      await this.fetchApp();
      await this.fetchAppCountry();
    } catch (error) {
      this.isEmpty = true;
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async fetchData(url = this.url) {
      this.loading = true;
      this.appCountries = null;
      this.appData = null;
      try {
        await this.processAppLink(url);
        await this.fetchAppCountry();
      } catch (error) {
        this.isEmpty = true;
        this.showNotification(
          "error",
          this.$t("Custom.error"),
          error.response.data.msg
        );
      } finally {
        this.loading = false;
      }
    },
    async fetchApp() {
      try {
        // const response = await getAppByStoreId(this.storeId);
        const response = await processAppByStoreId(this.storeId, this.country);
        if (response.data.status) {
          this.appData = response.data.data;
        } else {
          this.showNotification(
            "error",
            this.$t("Custom.error"),
            response.data.msg
          );
        }
      } catch (error) {
        this.showNotification(
          "error",
          this.$t("Custom.error"),
          error.response.data.msg
        );
      }
    },
    async processAppLink(url = this.url) {
      if (!url) return;
      try {
        const response = await getApp(url);
        if (response.data.status) {
          this.appData = response.data.data;
          this.showNotification(
            "success",
            this.$t("Custom.success"),
            response.data.msg
          );
        } else {
          this.showNotification(
            "error",
            this.$t("Custom.error"),
            response.data.msg
          );
        }
      } catch (error) {
        this.loading = false;
        this.showNotification(
          "error",
          this.$t("Custom.error"),
          response.data.msg
        );
      }
    },
    async fetchAppCountry() {
      if (this.appCountries && this.appCountries.length > 0) return;
      try {
        const payload =
          this.appData.country.countryShortName === "US"
            ? { appId: this.appData.app.id }
            : { appId: this.appData.app.appId };

        const response = await getAppCountries(payload.appId);
        if (response.data.status) {
          this.appCountries = response.data.data.map((item) => ({
            ...item.country,
            appUrl: item.appUrl,
          }));
        } else {
          this.showNotification(
            "error",
            this.$t("Custom.error"),
            response.data.msg
          );
        }
      } catch (error) {
        this.showNotification(
          "error",
          this.$t("Custom.error"),
          error.response.data.msg
        );
      }
    },
    showNotification(type, title, message) {
      this.notification = {
        show: true,
        key: Date.now(),
        type,
        title,
        message,
      };
    },
    toggleVisibility(visible) {
      this.$refs.dynamicVisibility.toggle(visible);
    },
  },
};
</script>
